import React, { useEffect } from 'react';
import { sendScreenEvent } from '@useblu/blu-lytics';
import { Button, Drawer, TextListItem, Typography } from '@useblu/ocean-react';
import { PaymentMethods } from '@/pages/Checkout/types/paymentLinkContextTypes';

import * as S from '../styles';
import useInstallmentsDrawer, {
  APPLE_PAY_MAX_INSTALLMENTS,
} from './useInstallmentsDrawer';

interface InstallmentsDrawerProps {
  open: boolean;
  handleClose: () => void;
  type: PaymentMethods;
}

const InstallmentsDrawer = ({
  open,
  handleClose,
  type,
}: InstallmentsDrawerProps) => {
  const {
    handlePay,
    installment,
    installmentsOptions,
    setInstallment,
    showApplePayInstallmentsNotice,
  } = useInstallmentsDrawer(type);

  useEffect(() => {
    if (open) {
      sendScreenEvent('link_blu_checkout_wallet_installments_view');
    }
  }, [open]);

  const handlePayment = async () => {
    handlePay();
    handleClose();
  };

  return (
    <Drawer open={open} overlayClose={handleClose} onDrawerClose={handleClose}>
      <S.DrawerContent>
        <Typography variant="heading3">
          Em quantas vezes você quer pagar?
        </Typography>
        <S.ListOption>
          {installmentsOptions.map(option => (
            <S.Option key={option.value}>
              <TextListItem
                title={option.title}
                description={option.description}
                radio={{
                  value: option.value,
                  name: 'installments',
                  checked: installment?.number === option.value,
                  onChange: () => setInstallment(option.installment),
                }}
              />
            </S.Option>
          ))}
        </S.ListOption>
        {showApplePayInstallmentsNotice && (
          <Typography variant="caption">
            * Pagamentos através da Apple Pay só podem ser parcelados até{' '}
            {APPLE_PAY_MAX_INSTALLMENTS}x
          </Typography>
        )}
      </S.DrawerContent>
      <S.DrawerAction>
        <Button onClick={handlePayment}>
          Pagar em {installment?.number} vezes
        </Button>
      </S.DrawerAction>
    </Drawer>
  );
};

export default InstallmentsDrawer;
